import _definePage_default_0 from '/opt/buildhome/repo/src/pages/avatars/[id].vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/opt/buildhome/repo/src/pages/avatars/create.vue?definePage&vue&lang.tsx'
import _definePage_default_3 from '/opt/buildhome/repo/src/pages/avatars/library/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_4 from '/opt/buildhome/repo/src/pages/avatars/material-guide.vue?definePage&vue&lang.tsx'

export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/opt/buildhome/repo/src/pages/index.vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/:all(.*)',
    name: '/[...all]',
    component: () => import('/opt/buildhome/repo/src/pages/[...all].vue'),
    /* no children */
    meta: {
      "layout": "default"
    },
  },
  {
    path: '/apps',
    /* internal name: '/apps' */
    /* no component */
    children: [
      {
        path: '',
        name: '/apps/',
        component: () => import('/opt/buildhome/repo/src/pages/apps/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/apps/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/apps/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/avatars',
    /* internal name: '/avatars' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: ':id',
          name: '/avatars/[id]',
          component: () => import('/opt/buildhome/repo/src/pages/avatars/[id].vue'),
          /* no children */
        },
        _definePage_default_0
      ),
      _mergeRouteRecord(
        {
          path: 'create',
          name: '/avatars/create',
          component: () => import('/opt/buildhome/repo/src/pages/avatars/create.vue'),
          /* no children */
        },
        _definePage_default_2
      ),
      {
        path: 'creations',
        /* internal name: '/avatars/creations' */
        /* no component */
        children: [
          {
            path: 'buy',
            name: '/avatars/creations/buy',
            component: () => import('/opt/buildhome/repo/src/pages/avatars/creations/buy.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'custom',
        name: '/avatars/custom',
        component: () => import('/opt/buildhome/repo/src/pages/avatars/custom.vue'),
        /* no children */
      },
      {
        path: 'library',
        /* internal name: '/avatars/library' */
        /* no component */
        children: [
          {
            path: '',
            name: '/avatars/library/',
            component: () => import('/opt/buildhome/repo/src/pages/avatars/library/index.vue'),
            /* no children */
          },
          _mergeRouteRecord(
            {
              path: ':id',
              name: '/avatars/library/[id]',
              component: () => import('/opt/buildhome/repo/src/pages/avatars/library/[id].vue'),
              /* no children */
            },
            _definePage_default_3
          )
        ],
      },
      _mergeRouteRecord(
        {
          path: 'material-guide',
          name: '/avatars/material-guide',
          component: () => import('/opt/buildhome/repo/src/pages/avatars/material-guide.vue'),
          /* no children */
        },
        _definePage_default_4
      ),
      {
        path: 'personal',
        name: '/avatars/personal',
        component: () => import('/opt/buildhome/repo/src/pages/avatars/personal.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/cli',
    /* internal name: '/cli' */
    /* no component */
    children: [
      {
        path: 'auth',
        /* internal name: '/cli/auth' */
        /* no component */
        children: [
          {
            path: ':authRequestId',
            name: '/cli/auth/[authRequestId]',
            component: () => import('/opt/buildhome/repo/src/pages/cli/auth/[authRequestId].vue'),
            /* no children */
            meta: {
              "layout": "auth",
              "public": true
            },
          }
        ],
      }
    ],
  },
  {
    path: '/download',
    /* internal name: '/download' */
    /* no component */
    children: [
      {
        path: ':id',
        name: '/download/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/download/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/feedback',
    /* internal name: '/feedback' */
    /* no component */
    children: [
      {
        path: '',
        name: '/feedback/',
        component: () => import('/opt/buildhome/repo/src/pages/feedback/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/feedback/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/feedback/[id].vue'),
        /* no children */
      },
      {
        path: 'create',
        name: '/feedback/create',
        component: () => import('/opt/buildhome/repo/src/pages/feedback/create.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/home',
    name: '/home',
    component: () => import('/opt/buildhome/repo/src/pages/home.vue'),
    /* no children */
  },
  {
    path: '/integrate',
    name: '/integrate',
    component: () => import('/opt/buildhome/repo/src/pages/integrate.vue'),
    /* no children */
  },
  {
    path: '/invite',
    name: '/invite',
    component: () => import('/opt/buildhome/repo/src/pages/invite.vue'),
    /* no children */
    meta: {
      "layout": "auth",
      "public": true
    },
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/opt/buildhome/repo/src/pages/login.vue'),
    /* no children */
    meta: {
      "layout": "auth",
      "public": true
    },
  },
  {
    path: '/notifications',
    /* internal name: '/notifications' */
    /* no component */
    children: [
      {
        path: '',
        name: '/notifications/',
        component: () => import('/opt/buildhome/repo/src/pages/notifications/index.vue'),
        /* no children */
      },
      {
        path: 'announcements',
        /* internal name: '/notifications/announcements' */
        /* no component */
        children: [
          {
            path: ':id',
            name: '/notifications/announcements/[id]',
            component: () => import('/opt/buildhome/repo/src/pages/notifications/announcements/[id].vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/pricing',
    name: '/pricing',
    component: () => import('/opt/buildhome/repo/src/pages/pricing.vue'),
    /* no children */
  },
  {
    path: '/settings',
    name: '/settings',
    component: () => import('/opt/buildhome/repo/src/pages/settings.vue'),
    /* no children */
  },
  {
    path: '/stats',
    name: '/stats',
    component: () => import('/opt/buildhome/repo/src/pages/stats.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

